export const Footer = () => {
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer__grid">
                    <div className="footer__brand">
                        <div className="footer__logos">
                            <a href="#" className="footer__logo" aria-label="MAM Home">
                                <img src="/assets/mam-logo.png" alt="MAM" className="footer-logo-image" width="100" />
                            </a>
                            <a href="#" className="footer__logo" aria-label="MCI - Magnolia Creative">
                                <img src="/assets/magnolia-creative-logo.png" alt="Magnolia Creative" className="footer-logo-image mci-logo" width="80" />
                            </a>
                        </div>
                        <p className="footer__tagline">
                            Magnolia Agentic Medley (MAM) is an AI assisted information platform owned by Magnolia Creative Inc.
                        </p>
                    </div>

                    <div className="footer__disclaimer">
                        <p className="footer__disclaimer-text">
                            <strong>Disclaimer:</strong> Please note that this platform is <strong>NOT</strong> automated investing, a trading system, or a performance service. All decisions remain fully under your control.
                        </p>
                    </div>
                </div>

                <div className="footer__bottom">
                    <p className="footer__copyright">&copy; 2026 Magnolia Creative Inc. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};